 //Code for cookied functions starts
 function deleteCookie(name, path, domain) {
    document.cookie =
        encodeURIComponent(name) +
        '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' +
        (path ? '; path=' + path : '') +
        (domain ? '; domain=' + domain : '');
}
                
function setCookie(key, value, expiry) {
        var expires = new Date();
        expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
        document.cookie = key + '=' + value + ';expires=' + expires.toUTCString()+";path=/";
    }
    function getCookie(key) {
      var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
      return keyValue ? keyValue[2] : null;
    } 
    //Code for cookied functions ends

// 

window.customRemoveFunction = function(event) {
    event.preventDefault();
setTimeout(() => {
  

    let row = event.target.closest("tr.cart-items__table-row");
    console.log("Custom function called", row);

    let connect_id = $(row).attr("data-timestamp");
    console.log("connect_id---", connect_id);

    let updates = {};

    // $(`tr.cart-items__table-row[data-timestamp='${connect_id}']`).each(function(i, j) {
    $(`tr.cart-items__table-row:not([custom-order])[data-timestamp='${connect_id}']`).each(function(i, j) {
        let key = $(j).attr("data-key");
        if (key) {
            updates[key] = 0; // remove item
        }
    });

    console.log("updates", updates);

    $.ajax({
        type: "POST",
        url: "/cart/update.js",
        data: {
            updates: updates
        },
        dataType: "json",
        success: async function(cart) {
            console.log("All items removed", cart);
            // optional: location.reload();
              var cart = await (await fetch('/cart.js')).json();
      var { CartUpdateEvent } = await import('@theme/events');
      document.dispatchEvent(new CartUpdateEvent(cart, 'cart-drawer-component'));
      var cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();

        },
        error: function(err) {
            console.log("Remove error", err);
        }
    });
    }, 2000);
}

// Delegate click — only triggers for custom-order rows
$(document).on(
    "click",
    "tr.cart-items__table-row[custom-order] button.cart-items__remove",
    window.customRemoveFunction
);
// $(document).on("click","tr.cart-items__table-row[custom-order] button.cart-items__remove",function(e){
// // $("tr.cart-items__table-row[custom-order] button.cart-items__remove").click(function (e) {

//     e.preventDefault();

//     let connect_id = $(this)
//         .parents(".cart-items__table-row")
//         .attr("data-timestamp");
//         console.log("connect_id---",connect_id);
        

//     // same timestamp wali rows
// $(`tr.cart-items__table-row:not([custom-order])[data-timestamp='${connect_id}']`)
//  let updates = {};

//     $(`tr.cart-items__table-row[data-timestamp='${connect_id}']`).each(function (i,j) {

//         let key = $(j).attr("data-key");

//         if (key) {
//             updates[key] = 0; // remove item
//         }
//     });
// console.log("vvv",updates)
// $.ajax({
//         type: "POST",
//         url: "/cart/update.js",
//         data: {
//             updates: updates
//         },
//         dataType: "json",
//         success: function (cart) {
//             console.log("All items removed", cart);

//             // optional
//             // location.reload();
//         },
//         error: function (err) {
//             console.log("Remove error", err);
//         }
//     });

// });
// 


  document.addEventListener("DOMContentLoaded", function () {
 $("product-card .klaviyo-bis-trigger").addClass("cstm-klaviyo-bis-trigger")
 $("product-card .klaviyo-bis-trigger").removeClass("klaviyo-bis-trigger")
/****** Code for showing loader on cart drawer and cart page starts******/
   function debounce(func, delay) {
    let timer;

    return function (...args) {
        clearTimeout(timer);

        timer = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
}

const debouncedHandleCartAction = debounce(function ($el) {
    handleCartAction($el);
}, 300);

$(document).on(
    "click",
    ".cart-items__table-row cart-quantity-selector-component button",
    function () {
        debouncedHandleCartAction($(this));
    }
);

$(document).on(
    "click",
    ".cart-items__table-row button.button.cart-items__remove",
    function () {
        debouncedHandleCartAction($(this));
    }
);

$(document).on(
    "change",
    ".cart-items .quantity-selector input",
    function () {
        debouncedHandleCartAction($(this));
    }
);

function handleCartAction($el) {
    let b_id = $el.closest("tr.cart-items__table-row").attr("data-b-product");

    $(".loading-jtpl").removeClass("visually-hidden");

    console.log("bbbb", b_id);
    console.log(
        "oo",
        $(`tr.cart-items__table-row[data-b-product='${b_id}'] .loading`).length
    );
}
/****** Code for showing loader on cart drawer and cart page ends******/

/****** Code for registration pages desigining starts******/
  if (!document.body.classList.contains("cstm-registration-form")) return;

  function applyStyles() {
    const host = document.querySelector('shopify-forms-embed');
    if (!host || !host.shadowRoot) return false;

    const shadow = host.shadowRoot;

    // Prevent duplicate injection
    if (shadow.querySelector('#custom-style')) return true;

    const style = document.createElement('style');
    style.id = 'custom-style';
    style.textContent = `
      p{
        font-size:14px !important;
      }
    `;

    shadow.appendChild(style);
    return true;
  }

  // Retry until available (max ~5 seconds)
  let attempts = 0;
  const interval = setInterval(() => {
    if (applyStyles() || attempts > 50) {
      clearInterval(interval);
    }
    attempts++;
  }, 100);
});
/****** Code for registration pages desigining ends******/


/****** Code for check uses on registration pages starts******/
document.addEventListener("DOMContentLoaded", function () {
  if (!document.body.classList.contains("cstm-registration-form")) return;

  function debounce(fn, delay) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  function applyScript() {
    const host = document.querySelector('shopify-forms-embed');
    if (!host || !host.shadowRoot) return false;

    const shadow = host.shadowRoot;
    if (shadow.querySelector('[data-email-validation]')) return true;

    const emailInput = shadow.querySelector('input[id="email"]');
    const first_name = shadow.querySelector('input[id="first_name"]');
    const last_name = shadow.querySelector('input[id="last_name"]');
    const company_name = shadow.querySelector('input[id="company_name"]');
    const form = shadow.querySelector("form");

    if (!emailInput || !form) return false;

    emailInput.setAttribute('data-email-validation', 'true');

    let lastCheckedEmail = "";
    // const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const emailPattern =  /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;

    //  Named handlers so they can be properly removed
    function blockSubmit(e) {
      e.preventDefault();
    }

    function lockForm() {
      form.classList.add("not-validate");
      form.addEventListener('submit', blockSubmit);
      const btn = form.querySelector("button[type='submit']");
      if (btn) btn.addEventListener('click', blockSubmit);
    }

    function unlockForm() {
      form.classList.remove("not-validate");
      form.removeEventListener('submit', blockSubmit);  // Works now
      const btn = form.querySelector("button[type='submit']");
      if (btn) btn.removeEventListener('click', blockSubmit);  // Works now
    }

    const validateAndCallAPI = debounce(async function () {
      const value = emailInput.value.trim();
      const allFilled = value && first_name?.value.trim() && last_name?.value.trim() && company_name?.value.trim();

      // if (!allFilled) return;

      // Validate format first
      if (!emailPattern.test(value)) {
        lockForm();
        emailInput.style.boxShadow = "0 0 0 2px var(--form-error-color)";
        // emailInput.setCustomValidity("Email is invalid");
        emailInput.closest('div').querySelector('output[role="alert"]')?.remove();
        emailInput.closest('div').insertAdjacentHTML('beforeend',
          '<output role="alert" style="color:red;margin-top:5px;">Email is invalid</output>'
        );
        return;
      }

      if (value === lastCheckedEmail) return;
      lastCheckedEmail = value;

      try {
        document.querySelector(".cstm-liquid-section:has(.loader--spinner)").style.display='block';
        lockForm(); // Lock while checking

        const data = await emailCheckAPI(value);
        console.log("RRR",data);
        

        if (data.exists) {
          emailInput.style.boxShadow = "0 0 0 2px var(--form-error-color)";
          emailInput.closest('div').querySelector('output[role="alert"]')?.remove();
          emailInput.closest('div').insertAdjacentHTML('beforeend',
            '<output role="alert" style="color:red;margin-top:5px;">Email already registered</output>'
          );
          document.querySelector(".cstm-liquid-section:has(.loader--spinner)").style.display='none';
        } else {
          emailInput.style.boxShadow = "0 0 0 2px green";
          emailInput.closest('div').querySelector('output[role="alert"]')?.remove();
          unlockForm(); // Properly unlocks now
          document.querySelector(".cstm-liquid-section:has(.loader--spinner)").style.display='none';
        }

      } catch (err) {
        console.error(err);
        emailInput.style.border = "1px solid red";
        // emailInput.setCustomValidity("Error validating email");
      }

    }, 500);

    emailInput.addEventListener('input', validateAndCallAPI);
    return true;
  }

  let attempts = 0;
  const interval = setInterval(() => {
    if (applyScript() || attempts > 50) clearInterval(interval);
    attempts++;
  }, 100);
});
function emailCheckAPI(email) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: "https://jeronone.com/test-server/hp/microfiber/index.php",
      type: "POST",
      contentType: "application/json",
      data: JSON.stringify({ email: email }),
      
      success: function(response) {
        try {
          let data = typeof response === "string" ? JSON.parse(response) : response;

          console.log("Response:", data);
          $("#result").text(JSON.stringify(data));

          if (data.success) {
            resolve({ exists: true });
          } else {
            resolve({ exists: false });
          }

        } catch (err) {
          reject(err);
        }
      },

      error: function(xhr, status, error) {
        console.error("Error:", error);
        $("#result").text("Something went wrong!");
        reject(error);
      }
    });
  });
}
/****** Code for check uses on registration pages ends******/

/****** Code for Klaviyo form custom property starts******/
  window.addEventListener("klaviyoForms", function(e) { 
    console.log("klaviyoForms===", e);

    // Track when the form is opened
    if (e.detail.type == 'open' || e.detail.type == 'embedOpen') {
        klaviyo.track('Viewed Form - Tracked Profile', { 
            formId: e.detail.formId,
            page_source: window.location.pathname // Adds the current URL
        });
        console.log("k-type===", e);
    }

    // Track when the form is submitted
    if (e.detail.type == 'submit' || e.detail.type == 'redirectedToUrl') {
        klaviyo.track('Submitted Form - Tracked Profile', {
            formId: e.detail.formId,
            page_source: window.location.pathname // Adds the current URL
        });
        klaviyo.identify({
            'page_source': window.location.pathname
        });
        setTimeout(() => {
          $(":not(form).klaviyo-form").addClass("submitted")
        }, 500);
        
        console.log("k-type-s===", e);
    }
});
/****** Code for Klaviyo form custom property ends******/


document.addEventListener("DOMContentLoaded",function () {
  printingQuantityValid();

  $(".custom-search-box .predictive-search-form__header input#cmdk-input").on("focus", function () {
    $(this).parents("predictive-search-component").find(".predictive-search-form__content-wrapper").addClass("active");
});

$(document).on("click", function (e) {
  if (!$(e.target).closest(".predictive-search-form").length) {
    $(".custom-search-box .predictive-search-form__content-wrapper").removeClass("active");
  }
});

$(".menu-list__list-item.has-submenu").click(function (e) {
  e.preventDefault();
  // $(".menu-list__list-item.has-submenu").removeClass("active");
  $(this).toggleClass("active")
  $(".mobile-right-announce-wrapper .dropdown-button").removeClass("open");
  $("#dropdown-menu-mobile-custom-right-announcement-bar").hide();

  // Close small promo
  $(".small-promo-outer .small-promo-2").removeClass("open");
  $(".small_promo_2_wrapper").hide();
})
 
$(document).on("cart:update",function (e) {
  console.log("ee--cart:update",e)
  setTimeout(() => {
    $('.cart-icon-details-wrapper .header-cart-details').load(location.href + ' .cart-icon-details-wrapper .header-cart-details');
    
  }, 100);
  
})

//  $('#dropdown-menu-account').hide();

    // Toggle dropdown on click
    $(".account-btn-wrapper.logged-in +.account-btn-details").click(function(e) {
        e.stopPropagation(); // prevent clicks from bubbling up
        $("#dropdown-menu-account").toggle(); // show if hidden, hide if visible
    });

    // Optional: click outside to hide the dropdown
    $(document).click(function() {
        $("#dropdown-menu-account").hide();
    });

    // Optional: prevent the dropdown itself from closing when clicked inside
    $("#dropdown-menu-account").click(function(e) {
        e.stopPropagation();
    });



});

// Code for changing intelligems price on product page starts
window.addEventListener('ig:ready', () => {
 
  let v_id=$("[id^=ProductInformation] form input[name=id]").val()
  if (v_id) {
    $('[id^="ProductInformation"] .price_wrapper_jtpl .price').not('quick-add-dialog .price').css("opacity", "1")
    getVariantDiscount(v_id);
    if ($("body").hasClass("not-logged-in")) {
      updatePriceBanner()
      console.log("updatePriceBanner-----");
      
    }
  }

});

if (document.querySelector("body").classList.contains("cstm-product-listing")) {
  $(document).on("change", '.variant-option__button-label input[type="radio"]', function () {
setTimeout(() => {
    $("label.variant-option__button-label:has(input[type=radio]:checked)")
        .trigger("click");
}, 2000);
});

}
    $(document).on("variant:update",function (e) {
    console.log("vvv",e.originalEvent.detail.resource.id)
    console.log("ee",e);
    
    let v_id = e.originalEvent.detail.resource.id;
    getVariantDiscount(`${v_id}`);
      // let colorValue=event.detail?.resource.title;
    // Code used for property marking starts
    printingQuantityValid()
// Code used for property marking ends
    })

window.getVariantDiscount= function(v_id) {
  let discount = Number(window.igData.price.getDiscountByVariantId(v_id));
    let price = Number(window.igData.price.getPriceByVariantId(v_id));
    
    let finalPrice = price - (discount || 0);
    
    console.log("Variant:", v_id);
    console.log("Price:", price);
    console.log("Discount:", discount);
    console.log("Final:", finalPrice);
    let total = (discount/100)+price 
    let dis_percent = parseInt(((discount/100)/total)*100)
    
    if (price>0) {
      $(".product-details .price_wrapper_jtpl .price").text(`$${price}`);
      $(".customer-quantity-box .quantity-wholesale-price").text(`$${(discount/100).toFixed(2)}`)
      $(".quantity-retail-price").text(`$${total.toFixed(2)}`)
      $(".customer-quantity-box .quantity-percentage-discount").text(`${dis_percent}%`)
      $(".igtg-price-container").show();
      console.log("Disp----",dis_percent);
      
    }
}

function updatePriceBanner() {
  var campaigns_data = igData.campaigns.getAll();

  for(var zz=0; zz<campaigns_data.length; zz++){
    var name = campaigns_data[zz].name;
   var camp_desc = campaigns_data[zz].description;
    camp_desc = camp_desc.replace('"','');
    camp_desc = camp_desc.replace("'",'');
    var tiers_length = campaigns_data[zz].discount.tiers.length;
    var discountType = campaigns_data[zz].discount.discountType;
    var ret = parseInt(tiers_length) - 1 ;
    var max_price = campaigns_data[zz].discount.tiers[ret].maximumUnits;
    var minUnit = campaigns_data[zz].discount.tiers[ret].minimumUnits;

  var name_text = $("input[name='sku']").val().toUpperCase();
     var name_upr = name.toUpperCase();
     var description_text = $(".product-details h1").text().trim().toUpperCase();
     var description_upr = camp_desc.toUpperCase();
if($(".template-product .multi-tier-wrapper").length > 0 && (name_upr == name_text ||  description_upr.replace('"','') == description_text.replace('"','').replace('"',''))){
       var product_html_1 = '<div class="multi-tier-items">Order More</div>';
       var product_html_2 = '<div class="multi-tier-items">Save More!</div>';
       var tiers_data = campaigns_data[zz].discount.tiers;
        for(var xx=0; xx< tiers_data.length ; xx++){
          var max_price_2 = tiers_data[xx].maximumUnits;
          var minUnit_2 = tiers_data[xx].minimumUnits;
          //  console.log(tiers_data[xx]);
            var max_price_2 = $(".price_wrapper_jtpl .price").text();
            // console.log("max_price_2"+ max_price_2);
          var main_price_2 = max_price_2.replace("$","");
          var product_type = $(".product-details .product-type").text();
          if(product_type.indexOf("each") > -1){
            var pro_type_data = "each";
          }else{
            var pro_type_data = "pack";
          }
         if(discountType == "percentage"){
           var unitDiscount_2 = parseFloat(main_price_2) * tiers_data[xx].unitDiscount/100;
          }else{
          var unitDiscount_2 = tiers_data[xx].unitDiscount;
          }
          var disc_price = parseFloat(main_price_2) - parseFloat(unitDiscount_2);
          if(discountType == "percentage"){
           var persentDiscount_2 = tiers_data[xx].unitDiscount
          }else{
          var persentDiscount_2 = 100 - (disc_price / parseFloat(main_price_2)*100);
          }
          product_html_1+= '<div class="multi-tier-items"><span id="intelligems-quantity-jtpl-'+xx+'" class="intelligems-quantity-jtpl" data-index="'+xx+'" data-qty="'+minUnit_2+'">'+minUnit_2+' </span>+ <span> '+pro_type_data+'</span></div>';
          product_html_2+= '<div class="multi-tier-items"><span id="intelligems-discounted-price-jtpl-'+xx+'" class="intelligems-discounted-price-jtpl" data-index="'+xx+'" data-tier-price='+disc_price.toFixed(2)+'>$'+disc_price.toFixed(2)+' </span><span>/ '+pro_type_data+'</span><span class="precentage_offer"><span id="intelligems-precentage-price-jtpl-'+xx+'" class="intelligems-precentage-price-jtpl">'+Math.round(persentDiscount_2)+'%</span> off</span></div>';
        }
      $(".multi-tier-wrapper .multi-tier-body:first-child .multi-tier-items-jtpl").html(product_html_1);
      $(".multi-tier-wrapper .multi-tier-body:last-child .multi-tier-items-jtpl").html(product_html_2);
      $(".popup-notification.product.multi-tier-breaks").attr("style","display:block !important");
    break;
      }else{
        $(".popup-notification.product.multi-tier-breaks").parents(".shopify-block").hide();
      }
} 
}



// Code for changing intelligems price on product page ends

//Code validating quantity for property marking starts
$("input[type=radio]:checked").val()
function printingQuantityValid() {
         var quantity_customiz = $(".product-details input.js-qty__num[name=quantity]").val();
    var quantity_customiz = parseInt(quantity_customiz);
    var min_qantty = $("add-to-cart-component .add-to-cart-button").attr("data-qty-min")
    var currnt_color =  $(".product-details input[type=radio]:checked").val()
    var min_qantty  = parseInt(min_qantty);
console.log(quantity_customiz+"======"+min_qantty)
    
    if(quantity_customiz >= min_qantty && currnt_color !== 'Black' && !currnt_color.includes(',')){
      $(".product-details add-to-cart-component .add-to-cart-button").attr("add_to_cart_click" ,"true")
    }else{
       $(".product-details add-to-cart-component .add-to-cart-button").removeAttr("add_to_cart_click")
    }
  }
  $(document).on("keyup",".product-details input.js-qty__num[name=quantity]",function () {
    printingQuantityValid();
  })
  let clickTimer;

$(".product-details quantity-selector-component button").on('click', function () {
  clearTimeout(clickTimer);

  clickTimer = setTimeout(function () {
    printingQuantityValid();
  }, 200); 
});
//Code validating quantity for property marking ends


// 
$("#customize-property-popup .pswp__button--close").click(function () {
   $("#customize-property-popup").css({
  "visibility": "hidden",
  "opacity": "0"
});
$("body").removeClass("button-popup-enable")
})

$(document).on('click','[add_to_cart_click]',function(e){
  e.preventDefault();
  e.stopImmediatePropagation();
  $("#customize-property-popup").css({
  "visibility": "visible",
  "opacity": "1"
});
let items=[]

var ProductHandle = $(this).attr("product-handle")
    $('body').addClass('button-popup-enable');
    $('#customize-property-popup.button-select-popup').addClass('second-button-show');
      if($('label.variant-option__button-label:has(input[type=radio]:checked)').find("img").length > 0){
        var current_data_image = $('label.variant-option__button-label:has(input[type=radio]:checked)').find("img").attr("src");
      }
      else {
        // var current_data_image = $('.prpty-marking-select option:selected').attr('data-variant-img');
      }
      setCookie("image",current_data_image,180);
      var pro_title = $(".product-details .view-product-title").text().trim();
      var pro_price = $(".product-details .price").text().trim();
      var pro_qty   = $('.product-details input.js-qty__num[name=quantity]').val();
      var current_price = $(this).attr('price_qty');
      var final_price = (pro_qty*current_price);
      if($('.product--container').find('.option-header').length > 0 ){
        var pro_varient = $("fieldset.variant-option legend").html().trim();
      }
      var pro_Type =$('.product--container').find('.price--main.product-page-style .product-type').text().trim();
      if($('form.variant-picker__form input[type=radio]:checked').length > 0){
        var varient_idd = $('form.variant-picker__form input[type=radio]:checked').attr("data-variant-id");
      }
      else{
        var varient_idd = $(".product-details input[name=id]").val();
      }
      var pro_image = getCookie("image");
    
      var newArr = '';
      newArr = varient_idd+"~"+pro_title+"~"+final_price+"~"+pro_qty+"~"+pro_image+"~"+pro_varient+"~"+current_price+"*";
       var pro_Type =$(".price_wrapper_jtpl [ref=priceContainer]").data("p-type").trim();
       var pro_color = $('form.variant-picker__form input[type=radio]:checked').val().trim().toLowerCase();
      var data_to_add = $(this).attr("data-addon");
      var data_to_addPack = $(this).attr("data-qty-pack");

      if($("#intelligems-discounted-price-jtpl-0").length){
      var first_tier_discount = $("#intelligems-discounted-price-jtpl-0").attr("data-tier-price").trim();
      setCookie("FirstTierDiscount", first_tier_discount, 30);
      }
       if($("#intelligems-discounted-price-jtpl-1").length){
      var second_tier_discount = $("#intelligems-discounted-price-jtpl-1").attr("data-tier-price").trim();
      setCookie("SecondTierDiscount", second_tier_discount, 30);
       }
      if($("#intelligems-discounted-price-jtpl-2").length){
      var third_tier_discount = $("#intelligems-discounted-price-jtpl-2").attr("data-tier-price").trim();
      setCookie("ThirdTierDiscount", third_tier_discount, 30);
      }
      if($("#intelligems-quantity-jtpl-0").length){
      var first_tier_quatity = $("#intelligems-quantity-jtpl-0").text().trim();
      setCookie("FirstTierQuantity", first_tier_quatity, 30);
      }
      if($("#intelligems-quantity-jtpl-1").length){
      var second_tier_quatity = $("#intelligems-quantity-jtpl-1").text().trim();
      setCookie("SecondTierQuantity", second_tier_quatity, 30);
      }
      if($("#intelligems-quantity-jtpl-2").length){
      var third_tier_quatity = $("#intelligems-quantity-jtpl-2").text().trim();
      setCookie("ThirdTierQuantity", third_tier_quatity, 30);
      }

      var pro_quantity = $('.product-details input.js-qty__num[name=quantity]').val();
        items.push(newArr);
        console.log("Items cookie---",newArr);
        console.log("Items cookie items---",items);
        
      var cookArr = getCookie("itemsArr");
      if(cookArr){
       var cookArrNew = [];
      cookArr = cookArr.split(',');
         setCookie("itemsArr",newArr,180);
      }else{
          setCookie("itemsArr",newArr,180);
      }
     console.log('cookie set value : ' + getCookie("itemsArr"));
      $('.dta_crt_page').attr('product_cart_id',varient_idd);
      $('.dta_crt_page').attr('product_cart_qty',pro_qty);
      $('.customizer-button-outer-jtpl').removeClass('hidden');
      setCookie("currentProduct", pro_title, 30);
      setCookie("currentProductPrice", pro_price, 30);
      setCookie("currentProductType", pro_Type, 30);
      setCookie("currentPageType", "productPage", 30);
      setCookie("currntProductColor", pro_color, 30);
      setCookie("currntProductQauntity", pro_quantity, 30);
      setCookie("pintingPricesAddon", data_to_add, 30);
      setCookie("ProductPack", data_to_addPack, 30);
      setCookie("ProductHandle", ProductHandle, 30);
      if($(".tagged-customer-banner-intelligems-price-jtpl").length){
      var taggedCustomer = $(".tagged-customer-banner-intelligems-price-jtpl").html().trim();
      setCookie("taggedCustomer", taggedCustomer, 30);
      }
      var current_data_variant = $('.prpty-marking-select option:selected').attr('data-variant-id');
        $(".dta_crt_page").attr("product_cart_id",current_data_variant)

        return false;
})

// 



document.addEventListener("DOMContentLoaded", function () {
//  function deleteCookie(name, path, domain) {
//     document.cookie =
//         encodeURIComponent(name) +
//         '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' +
//         (path ? '; path=' + path : '') +
//         (domain ? '; domain=' + domain : '');
// }

// // Cookies on .microfiberwholesale.com
// deleteCookie('ig-fv', '/', '.microfiberwholesale.com');
// deleteCookie('ig-id', '/', '.microfiberwholesale.com');
// deleteCookie('ig-pv', '/', '.microfiberwholesale.com');

// // Cookies on www.microfiberwholesale.com
// deleteCookie('ig-location', '/', 'www.microfiberwholesale.com');
// deleteCookie('igTg', '/', 'www.microfiberwholesale.com');


// setTimeout(()=>{window.history.pushState(null, '', window.location.pathname);},2000)
  /* Open chat on click */
  const chatButtons = document.querySelectorAll(".live-chat-text");

  chatButtons.forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();

      if (typeof GorgiasChat !== "undefined") {
        GorgiasChat.open();
      }
    });
  });


  /* Close chat when clicking outside */
  document.addEventListener("click", function (e) {

    const chatWindow = document.querySelector('.widget-md[data-is-open="true"]');

    if (chatWindow && !chatWindow.contains(e.target)) {

      if (typeof GorgiasChat !== "undefined") {
        GorgiasChat.close();
      }

    }

  });

//   $('a[href^="#"]').on('click', function(e) {
//     e.preventDefault();

//     var target = $(this).attr('href');
//     if(target.length) {
//         var headerHeight = $('header-component').height();

//         $('html, body').animate({
//             scrollTop: target.offset().top - headerHeight
//         }, 300);
//     }
// });

});
// 
  $("body").on('click', '.scroller-content-jtpl a', function(e){  
 e.preventDefault();   
  var hrefScroll = $(this).attr("href"); 
    $('html, body').animate({
        scrollTop: $("."+hrefScroll).offset().top -100
    }, 10);
});

document.addEventListener('DOMContentLoaded', ()=>{
document.querySelectorAll('slideshow-component:not(.cstm-cart-page-upsells slideshow-component)').forEach(slider => {

  const track =
    slider.querySelector('.slider__slides') ||
    slider.querySelector('slideshow-slides');

  if (!track) return;

  const slides = track.children;
  if (!slides.length) return;

  const slideWidth = slides[0].getBoundingClientRect().width;

  const prev = slider.querySelector(
    'button[ref="previous"], .slider-button--prev, .slideshow__control--prev'
  );

  const next = slider.querySelector(
    'button[ref="next"], .slider-button--next, .slideshow__control--next'
  );

  function updateButtons() {
    const maxScroll = track.scrollWidth - track.clientWidth;

    if (prev) prev.disabled = track.scrollLeft <= 0;
    if (next) next.disabled = track.scrollLeft >= maxScroll - 2;
  }

  function scrollNext() {
    const maxScroll = track.scrollWidth - track.clientWidth;
    const newPos = Math.min(track.scrollLeft + slideWidth, maxScroll);

    track.scrollTo({
      left: newPos,
      behavior: "smooth"
    });
  }

  function scrollPrev() {
    const newPos = Math.max(track.scrollLeft - slideWidth, 0);

    track.scrollTo({
      left: newPos,
      behavior: "smooth"
    });
  }

  if (prev) {
    prev.addEventListener("click", e => {
      e.preventDefault();
      e.stopImmediatePropagation();
      scrollPrev();
    });
  }

  if (next) {
    next.addEventListener("click", e => {
      e.preventDefault();
      e.stopImmediatePropagation();
      scrollNext();
    });
  }

  // update buttons on scroll
  track.addEventListener("scroll", updateButtons);

  // initial state
  // updateButtons();

});


});
// 

/// Back to previous page js start..............




/*************Custom Printed Towels qty start *****************/
 document.addEventListener('click', function (e) {

    const btn = e.target.closest('.js-qty__adjust, button[name="minus"], button[name="plus"]');
    if (!btn) return;
    const form = btn.closest('form');
    if (!form) return;

    const input = form.querySelector('.js-qty__num');
    const errorMsg = form.querySelector('.qty-error-msg-cls');
    const minVal = parseInt(input.getAttribute('data-min')) || 1;

    setTimeout(() => {
      let currentVal = parseInt(input.value);
      
      if (currentVal <= minVal && (btn.name === 'minus' || btn.classList.contains('js-qty__adjust--minus'))) {
        input.value = minVal;
        if (errorMsg) {
          errorMsg.innerText = 'You need to add minimum ' + minVal + ' qty';
          errorMsg.style.display = 'block';
          form.classList.add('has-qty-error');
        }
      } else {

        if (errorMsg) {
          errorMsg.style.display = 'none';
          form.classList.remove('has-qty-error');
        }
      }
    }, 150);
});
/*************Custom Printed Towels qty End *****************/




/************* Start Card Drawer Upsell Functionality *****************/

// ================= EVENT DELEGATION =================

// Variant change
document.addEventListener('change', function (e) {
  if (e.target.matches('.upsell-item select')) {
    handleVariantChange(e.target);
  }
});

// Click (FIXED - arrows safe)
document.addEventListener('click', function (e) {

  if (
    e.target.closest('.slideshow__controls') ||
    e.target.closest('.slideshow-arrows')
  ) {
    return;
  }

  const btn = e.target.closest('.add-to-cart-upsell');
  if (btn) {
    e.preventDefault();
    e.stopPropagation();
    addUpsellToCart(btn);
  }
});

// ================= VARIANT CHANGE =================
function handleVariantChange(select) {
  const opt = select.options[select.selectedIndex];

  const parent =
    select.closest('.upsell-item') ||
    select.closest('[data-upsell]');

  if (!parent) return;

  const img = parent.querySelector('.main-upsell-img');
  if (opt.dataset.img && img) {
    img.src = opt.dataset.img;
  }

  const price = parent.querySelector('.upsell-price');
  if (opt.dataset.price && price) {
    price.innerText = opt.dataset.price;
  }

  const btn = parent.querySelector('.add-to-cart-upsell');
  if (btn) {
    btn.setAttribute('data-variant-id', opt.value);
    btn.setAttribute('data-sku', opt.dataset.sku || '');
  }
}

// ================= ADD TO CART =================
async function addUpsellToCart(btn) {
  const variantId = btn.getAttribute('data-variant-id');
  const itemSku = btn.getAttribute('data-sku');
  const originalText = btn.innerHTML;

  if (!variantId) return;

  // UI loading
  btn.innerText = "ADDING...";
  btn.style.pointerEvents = "none";
  btn.classList.add('loading');

  const formData = {
    items: [
      {
        id: variantId,
        quantity: 1,
        properties: {
          'ITEM NUMBER': itemSku
        }
      }
    ]
  };

  try {
    // Add to cart
    const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    });

    if (!res.ok) throw new Error('Add failed');

    // Get updated cart
    const cartRes = await fetch(window.Shopify.routes.root + 'cart.js');
    const cart = await cartRes.json();

    // Trigger cart update
    const { CartUpdateEvent } = await import('@theme/events');
    const updateEvent = new CartUpdateEvent(cart, 'cart-drawer', {
      itemCount: cart.item_count,
      source: 'upsell-item'
    });
    document.dispatchEvent(updateEvent);

    //  Smooth remove (NO BLANK)
    smoothRemoveUpsell(variantId);

    // Hide wrapper if empty
    const wrapper = document.querySelector('.cstm-cart-page-upsells');
    if (wrapper && !wrapper.querySelector('.upsell-item')) {
      wrapper.style.display = 'none';
    }

    //  Update layout + refresh slider
    setTimeout(() => {
      updateUpsellGridMode();
    }, 200);

    // Keep drawer open
    const drawer = document.querySelector("cart-drawer-component");
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    }

  } catch (err) {
    console.error("Upsell Add Error:", err);
  } finally {
    btn.innerHTML = originalText;
    btn.style.pointerEvents = "auto";
    btn.classList.remove('loading');
  }
}

// ================= SMOOTH REMOVE =================
function smoothRemoveUpsell(variantId) {
  const wrapper = document.querySelector('.cstm-cart-page-upsells');
  if (!wrapper) return;

  const item = [...wrapper.querySelectorAll('.upsell-item')].find(el => {
    const btn = el.querySelector('.add-to-cart-upsell');
    return btn && btn.getAttribute('data-variant-id') === variantId;
  });

  if (!item) return;

  // FIX height before animation (no jump)
  item.style.height = item.offsetHeight + 'px';

  requestAnimationFrame(() => {
    item.style.transition = 'all 0.35s ease';
    item.style.opacity = '0';
    item.style.transform = 'scale(0.95)';
    item.style.height = '0px';
    item.style.margin = '0';
    item.style.padding = '0';
  });

  setTimeout(() => {
    item.remove();
  }, 350);
}

// ================= SLIDER REFRESH =================


// ================= GRID CONTROL =================
function debounce(fn, delay = 120) {
  let t;
  return function () {
    clearTimeout(t);
    t = setTimeout(fn, delay);
  };
}

const updateUpsellGridMode = debounce(function () {
  const wrapper = document.querySelector('.cstm-cart-page-upsells');
  if (!wrapper) return;

  const realSlides = wrapper.querySelectorAll('slideshow-slide:not(.is-cloned)');
  const count = realSlides.length;

  const isDesktop = window.innerWidth >= 750;

  wrapper.classList.remove('is-grid-desktop', 'is-grid-mobile', 'is-grid');

  if (isDesktop && count <= 3) {
    wrapper.classList.add('is-grid-desktop', 'is-grid');
  }

  if (!isDesktop && count <= 1) {
    wrapper.classList.add('is-grid-mobile', 'is-grid');
  }
}, 150);

// ================= INIT =================

// Initial load
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    updateUpsellGridMode();
  }, 150);
});

// Resize
window.addEventListener('resize', updateUpsellGridMode);

// Mutation observer (cart drawer re-render fix)
const observer_2 = new MutationObserver(
  debounce(() => {
    updateUpsellGridMode();
  }, 120)
);

document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.cstm-cart-page-upsells');
  if (wrapper) {
    observer_2.observe(wrapper, {
      childList: true,
      subtree: true
    });
  }
});
(function waitForIframeInWrapper() {
    const wrapper = document.getElementById("PBarNextFrameWrapper");
    if (wrapper) {
      const iframe = wrapper.querySelector("#PBarNextFrame");
      if (iframe) {
        iframe.setAttribute("title", "myFrame");
      } else {
        setTimeout(waitForIframeInWrapper, 300);
      }
    } else {
      setTimeout(waitForIframeInWrapper, 300);
    }
  })();

  /************* End Card Drawer Upsell Functionality *****************/




/************* Start Addon Functionality *****************/
  
document.addEventListener("DOMContentLoaded",function () {
  const B_KEY = '_bundle_id';
  const L_KEY = '_linked_to';
  const NO_GROMMET_IMG = "https://cdn.shopify.com/s/files/1/0280/4006/9155/files/images-to-cut.png?v=1754023449";
  let isLocked = false;

  // --- 1. FIXED INITIAL LOAD UI ---
  function initAddonUI() {
    console.log("initAddonUI--");
    
    $('.product-addon-info').each(function() {
      const $p = $(this);
      // Force "No" state on page load
      $p.find('.js-selected-addon-id').val('');
      $p.find('.default-product-selector button').removeClass('active').filter('[data-value="no"]').addClass('active');
      $p.find('.variant-option').removeClass('selected').filter('.no-addon').addClass('selected');
      // Set the No Grommet image immediately
      $p.find('#product-featured-image').attr('src', NO_GROMMET_IMG);
    });
  }
  initAddonUI();

  // --- 2. GLOBAL BUBBLE UPDATE FUNCTION ---
  async function updateGlobalCartBubble() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const countSelectors = ['.cart-count', '.header__cart-count', '#cart-icon-bubble span', '.cart-link__count'];
      
      countSelectors.forEach(selector => {
        const el = document.querySelector(selector);
        if (el) {
          el.textContent = cart.item_count;
          if (cart.item_count === 0) el.classList.add('hidden');
          else el.classList.remove('hidden');
        }
      });
      document.dispatchEvent(new CustomEvent('cart:build', { detail: cart }));
    } catch (e) { console.error("Bubble update failed"); }
  }

  // --- 3. DRAWER REFRESH ---
  async function refreshHorizonDrawer() {
    try {
      const cart = await (await fetch('/cart.js')).json();
      const { CartUpdateEvent } = await import('@theme/events');
      document.dispatchEvent(new CartUpdateEvent(cart, 'cart-drawer-component'));
      updateGlobalCartBubble();
      const cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
    } catch (err) { updateGlobalCartBubble(); }
  }

  // --- 4. MASTER SYNC (AUTO DELETE) ---
  async function runMasterSync() {
    
    if (isLocked) return;
    console.log("Updating grommet--");
    isLocked = true;
    try {
      const response = await fetch('/cart.js', { cache: 'no-store' });
      const cart = await response.json();
      let updates = {};
      let needsUpdate = false;
      const activeBundleMap = {};

      cart.items.forEach(item => {
        if (item.properties && item.properties[B_KEY]) activeBundleMap[item.properties[B_KEY]] = item.quantity;
      });

      cart.items.forEach(item => {
        const linkedId = item.properties ? item.properties[L_KEY] : null;
        if (linkedId) {
          const parentQty = activeBundleMap[linkedId];
          if (parentQty === undefined) {
            updates[item.key] = 0;
            needsUpdate = true;
          } else if (item.quantity !== parentQty) {
            updates[item.key] = parentQty;
            needsUpdate = true;
          }
        }
      });

      if (needsUpdate) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
        await refreshHorizonDrawer();
      } else {
        updateGlobalCartBubble();
      }
    } catch (e) { console.error(e); } 
    finally { 
      isLocked = false; 
      console.log("Updating grommet+++");
      $(`.loading-jtpl`).addClass("visually-hidden")
    }
  }

  // GLOBAL FETCH INTERCEPTOR
  const { fetch: originalFetch } = window;
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    const url = typeof args[0] === 'string' ? args[0] : (args[0].url || "");
    if (url.includes('/cart/change') || url.includes('/cart/add') || url.includes('/cart/update') || url.includes('/cart/clear')) {
      setTimeout(runMasterSync, 500);
      setTimeout(updateGlobalCartBubble, 1000);
    }
    return response;
  };

  // --- 5. UI CLICK HANDLERS ---
  $(document).on('click', '.main-custom-grommets .default-product-selector button', function (e) {
    e.preventDefault();
    const $p = $(this).closest('.product-addon-info');
    $p.find('button').removeClass('active');
    $(this).addClass('active');
    const val = ($(this).data('value') === 'yes') ? $(this).data('id').toString() : '';
    $p.find('.js-selected-addon-id').val(val);
    if($(this).data('value') === 'no') $p.find('#product-featured-image').attr('src', NO_GROMMET_IMG);
  });

  $(document).on('click', '.main-custom-grommets .variant-option', function (e) {
    e.preventDefault();
    const $p = $(this).closest('.product-addon-info');
    $p.find('.variant-option').removeClass('selected');
    $(this).addClass('selected');
    const id = $(this).hasClass('no-addon') ? '' : $(this).data('id').toString();
    $p.find('.js-selected-addon-id').val(id);
    const newImg = $(this).data('image') || NO_GROMMET_IMG;
    $p.find('#product-featured-image').attr('src', newImg);
  });

  // --- 6. ADD TO CART ---
  $(document).on('click', 'add-to-cart-component button[type="submit"], .product-form__submit', async function (e) {
    const $btn = $(this);
    const $form = $btn.closest('form');
    const addonId = $('.js-selected-addon-id').filter(function() { return $(this).val() !== ""; }).first().val();

    if (addonId && !$btn.attr('data-processing')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      $btn.attr('data-processing', 'true').css('opacity', '0.5');

      const bId = `B-${Date.now()}`;
      const mainId = $form.find('[name="id"]').val();
      const qty = parseInt($form.find('[name="quantity"]').val() || 1);

      const props = { [B_KEY]: bId };
      $form.find('[name^="properties["]').each(function () {
        const keyMatch = $(this).attr('name').match(/\[(.*?)\]/);
        if (keyMatch) props[keyMatch[1]] = $(this).val();
      });

      if (!props['ITEM NUMBER']) {
        const manualSku = $('[data-testid="product-sku"], .product__sku').first().text().trim();
        if (manualSku) props['ITEM NUMBER'] = manualSku;
      }

      try {
        const addonProps = { [L_KEY]: bId };
        if (props['ITEM NUMBER']) addonProps['ITEM NUMBER'] = props['ITEM NUMBER'];

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [
              { id: parseInt(mainId), quantity: qty, properties: props },
              { id: parseInt(addonId), quantity: qty, properties: addonProps }
            ]
          })
        });
        
        // Reset to initial NO state after successful add
        initAddonUI();
        await refreshHorizonDrawer();
      } catch (err) {
        $form.submit();
      } finally {
        $btn.removeAttr('data-processing').css('opacity', '1');
      }
    }
  });

  setTimeout(runMasterSync, 1000);
});

/************* End Addon Functionality *****************/



document.addEventListener('DOMContentLoaded', function() {

  const videoLinks = document.querySelectorAll('.video-link');
  const popup = document.getElementById('video-popup');


  if (!popup || !videoLinks.length) return;

  const iframe = popup.querySelector('iframe');
  const closeBtn = popup.querySelector('.video-popup-close');
  const overlay = popup.querySelector('.video-popup-overlay');

  if (!iframe || !closeBtn || !overlay) return;

  videoLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();

      const videoUrl = link.dataset.video;
      if (!videoUrl) return;

      let embedUrl = '';

      if (videoUrl.includes('youtube.com')) {
        const id = new URL(videoUrl).searchParams.get('v');
        if (id) {
          embedUrl = `https://www.youtube.com/embed/${id}?autoplay=1`;
        }
      } 
      else if (videoUrl.includes('youtu.be')) {
        const id = videoUrl.split('/').pop();
        if (id) {
          embedUrl = `https://www.youtube.com/embed/${id}?autoplay=1`;
        }
      }

      if (embedUrl) {
        iframe.src = embedUrl;
        popup.style.display = 'flex';
        document.body.style.overflow = 'hidden';
      }
    });
  });

  function closePopup() {
    iframe.src = '';
    popup.style.display = 'none';
    document.body.style.overflow = '';
  }

  closeBtn.addEventListener('click', closePopup);
  overlay.addEventListener('click', closePopup);

});

  //===========Image Popup==========
 document.addEventListener('DOMContentLoaded', function() {

  const popup = document.getElementById('GlobalImagePopup');
  const popupImg = document.getElementById('PopupLargeImage');
  const closeBtn = document.querySelector('.close-popup-icon');
  const triggers = document.querySelectorAll('.open-popup');

  if (!popup || !popupImg || !closeBtn || !triggers.length) return;

  triggers.forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();

      const targetImg = this.querySelector('img');

      if (targetImg && targetImg.src) {
        popupImg.src = targetImg.src;
        popup.style.display = 'flex';
        document.body.style.overflow = 'hidden'; 
      }
    });
  });

  const closePopup = () => {
    popup.style.display = 'none';
    document.body.style.overflow = ''; 
  };

  closeBtn.addEventListener('click', closePopup);

  popup.addEventListener('click', (e) => {
    if (e.target === popup) {
      closePopup();
    }
  });

});



//FAQ click
$(".accordion .details > summary").on("click", function (e) {
    e.preventDefault();

    const $details = $(this).parent(".details");

    $details
        .closest(".accordion")
        .find(".details")
        .not($details)
        .removeAttr("open");

    $details.attr("open")
        ? $details.removeAttr("open")
        : $details.attr("open", true);
});



  


// ===========End Image Popup==========

// Back to previous page js start................
document.addEventListener('DOMContentLoaded', function () {
  let historyList = JSON.parse(sessionStorage.getItem("historyList")) || [];
  let currentUrl = window.location.href;

  // Avoid pushing duplicate consecutive URLs
  if (historyList.length === 0 || historyList[historyList.length - 1] !== currentUrl) {
    historyList.push(currentUrl);
    sessionStorage.setItem("historyList", JSON.stringify(historyList));
  }

  $(".keep-shopping-btn").on("click", function (event) {
    event.preventDefault();

    let historyList = JSON.parse(sessionStorage.getItem("historyList")) || [];

    // Go to previous page (second last item)
    let lastIndex = historyList.length - 2;
    let last_history = historyList[lastIndex];

    if (!last_history) {
      window.location.href = "https://www.microfiberwholesale.com/pages/keep-shopping";
    } else {
      window.location.href = last_history;
    }
  });
});
/// Back to previous page js start..............

/******* Code fo showing reviews on product recommendation starts *******/
(function () {
  function initObserver() {
    const targetSelector = ".product-recommendations .product-card .ruk_rating_snippet";

    const observer = new MutationObserver((mutations, obs) => {
      if (document.querySelector(targetSelector)) {
        console.log("Rating snippet found");

        if (typeof window.reInitStarRatings === "function") {
          window.reInitStarRatings();
        }

        obs.disconnect(); 
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  // Sirf product page pe run karo
  if (window.location.pathname.includes("/products/")) {
    initObserver();
  }
})();
window.reInitStarRatings = function () {
   ratingSnippet("ruk_rating_snippet", {
    store: "microfiber-wholesale",   // same value as your initial setup
    color: "#f90",          // match your original config
    linebreak: false,
    text: "Reviews"
  });
}



if (window.location.pathname === "/collections/all") {
    document.body.classList.add("collection-all-page");
  }
/******* Code fo showing reviews on product recommendation ends *******/


document.addEventListener("click", function (e) {
  const dropdown = document.querySelector(".custom-drop-down");

  if (!dropdown) return;

  if (dropdown.contains(e.target)) {
    dropdown.classList.toggle("open");
  } else {
    dropdown.classList.remove("open");
  }
});




// Remove strong tag of Blog 12th Page 
function removeInjectedStrong(scope = document) {
  scope.querySelectorAll('strong[data-start]').forEach(el => {
    const parent = el.parentNode;

    // move children 
    while (el.firstChild) {
      parent.insertBefore(el.firstChild, el);
    }

    // strong remove
    el.remove();
  });
}

// Initial load
document.addEventListener("DOMContentLoaded", () => {
  removeInjectedStrong();
});

// Pagination / AJAX render finding (MutationObserver)
const observer = new MutationObserver((mutations) => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (node.nodeType === 1) {
        removeInjectedStrong(node);
      }
    });
  });
});

// पूरे body को observe करो
observer.observe(document.body, {
  childList: true,
  subtree: true
});

